import React, { useState } from 'react';
import { StyledNavigationTabBar } from './NavigationTabBar.styles';
import { NavigationTabLink } from './NavigationTabLink';
import { HorizontalScroller } from '../HorizontalScroller/HorizontalScroller';
import { jsx as _jsx } from "react/jsx-runtime";
export const NavigationTabBar = ({
  links
}) => {
  const [activeElement, setActiveElement] = useState(undefined);
  return /*#__PURE__*/_jsx(HorizontalScroller, {
    activeElement: activeElement,
    children: /*#__PURE__*/_jsx(StyledNavigationTabBar, {
      children: links.map(link => /*#__PURE__*/_jsx(NavigationTabLink, {
        link: link,
        ref: ref => {
          if (ref && link.isActive) {
            setActiveElement(ref);
          }
        }
      }, link.path))
    })
  });
};